import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "PurchId",
      label: "采购订单编码",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "OrderAccount",
      label: "供应商帐户",
      sortable: true
    },
    {
      key: "OrderAccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },

    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },

    {
      key: "LineNumber",
      label: "行号",
      sortable: true
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "PurchQty",
      label: "数量",
      sortable: true,
      type: "integer",
      _precise: 6
    },
    {
      key: "PurchUnit",
      label: "单位",
      sortable: true
    },
    {
      key: "PurchPrice",
      label: "价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "LineAmount",
      label: "本币不含税",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },

    {
      key: "DeliveryDate",
      label: "交货日期",
      sortable: true,
      type: "date"
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username;
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    }
  ]
};

///前端验证
const rules = {};

const descriptor = {};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);
const methods = {
  async getData(_params) {
    // console.log(_.map(fields.default, "key"));
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_purchorder_and_line",
      {},
      {}
    );
    let _fields = [];

    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run();
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  }
};
export { biz_data, fields, methods, rules };

